import {QingApp} from "@/entity/QingApp";
import {ConsumerLightAppRelationEntity} from "@/entity/ConsumerLightAppRelationEntity";

export class ConsumerLightAppRelationReq {

    public userName = '';
    public consumerLightAppRelationEntityList: ConsumerLightAppRelationEntity[] =[];
}